export default __webpack_public_path__ + "static/media/Analysts_2025.84c3757f.png";